// HandoffChainBlock — who else needs to touch this draft before it goes
// live, rendered as a left-to-right pill chain with done / pending state.

import { cn } from '@/lib/utils';
import type { ComposerHandoffStepShape } from '@/data/types';

interface HandoffChainBlockProps {
    chain: ComposerHandoffStepShape[];
}

export default function HandoffChainBlock({ chain }: HandoffChainBlockProps) {
    if (chain.length === 0) return null;
    return (
        <div
            data-testid="workbench-handoff-chain"
            className="rounded-md border border-[rgb(var(--color-divider))] bg-[rgb(var(--color-surface-secondary)/0.4)] p-3"
        >
            <div className="text-card-title text-[rgb(var(--color-text-primary))] mb-2">
                Handoff chain
            </div>
            <div className="flex flex-wrap items-center gap-2">
                {chain.map((step, i) => (
                    <div key={i} className="flex items-center gap-2">
                        <span
                            className={cn(
                                'text-annotation px-2 py-0.5 rounded-button font-mono',
                                step.status === 'done'
                                    ? 'bg-[rgb(var(--color-rag-green)/0.15)] text-[rgb(var(--color-rag-green))]'
                                    : 'bg-[rgb(var(--color-surface)/0.6)] text-[rgb(var(--color-text-secondary))] border border-[rgb(var(--color-divider))]',
                            )}
                        >
                            {step.role} {step.status === 'done' ? '·done' : '·pending'}
                        </span>
                        {i < chain.length - 1 && (
                            <span className="text-[rgb(var(--color-text-tertiary))]">→</span>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
